import Endpoints from './Endpoints';
const CAMPAIGNID = process.env.REACT_APP_CAMPAIGN_ID;
const reqHeaders = new Headers();
reqHeaders.append('Content-Type', 'application/json');
reqHeaders.append('campaignid', CAMPAIGNID);

class Api {
    async register(formData) {
        const requestOptions = {
            method: 'POST',
            headers: reqHeaders,
            body: JSON.stringify(formData),
        };

        try {
            const respJson = await fetch(Endpoints.signup, requestOptions);
            return await respJson.json();
        } catch (error) {
            return error.message;
        }
    }

    async uploadImage(formData) {
        const requestOptions = {
            method: 'PUT',
            headers: reqHeaders,
            body: JSON.stringify(formData),
        };

        try {
            const respJson = await fetch(Endpoints.upload, requestOptions);
            return await respJson.json();
        } catch (error) {
            return error.message;
        }
    }

    async checkUnique(id) {
        const requestOptions = {
            method: 'GET',
            headers: reqHeaders,
        };

        try {
            const respJson = await fetch(`${Endpoints.unique}${id}`, requestOptions);
            return await respJson.json();
        } catch (error) {
            return error.message;
        }
    }

    async checkUserJourneyStatus(id) {
        const requestOptions = {
            method: 'GET',
            headers: reqHeaders,
        };

        try {
            const respJson = await fetch(`${Endpoints.journeyStatus}${id}`, requestOptions);
            return await respJson.json();
        } catch (error) {
            return error.message;
        }
    }

    async getNearbyLocations(formData) {
        const requestOptions = {
            method: 'POST',
            headers: reqHeaders,
            body: JSON.stringify(formData),
        };

        try {
            const respJson = await fetch(Endpoints.locations, requestOptions);
            return await respJson.json();
        } catch (error) {
            return error.message;
        }
    }

    async getDistanceBetween(formData) {
        const requestOptions = {
            method: 'POST',
            headers: reqHeaders,
            body: JSON.stringify(formData),
        };

        try {
            const respJson = await fetch(Endpoints.distance, requestOptions);
            return await respJson.json();
        } catch (error) {
            return error.message;
        }
    }

    async swipeUniqueCode(formData) {
        const requestOptions = {
            method: 'POST',
            headers: reqHeaders,
            body: JSON.stringify(formData),
        };

        try {
            const respJson = await fetch(Endpoints.swipe, requestOptions);
            let resp = await respJson.json();
            return resp;
        } catch (error) {
            return error.message;
        }
    }

    async redeemUniqueCode(formData) {
        const requestOptions = {
            method: 'POST',
            headers: reqHeaders,
            body: JSON.stringify(formData),
        };

        try {
            const respJson = await fetch(Endpoints.redeem, requestOptions);
            let resp = await respJson.json();
            return resp;
        } catch (error) {
            return error.message;
        }
    }

    async setSelectedVenue(uniqueCode, venueId, serve) {
        const formData = {
            code: uniqueCode,
            venueId: venueId,
            serve: serve,
        };
        const requestOptions = {
            method: 'POST',
            headers: reqHeaders,
            body: JSON.stringify(formData),
        };

        try {
            const respJson = await fetch(Endpoints.venueSelect, requestOptions);
            return await respJson.json();
        } catch (error) {
            return error.message;
        }
    }

    async getSelectedVenue(venueId) {
        const requestOptions = {
            method: 'GET',
            headers: reqHeaders,
        };

        try {
            const respJson = await fetch(`${Endpoints.selectedVenue}${venueId}`, requestOptions);
            return await respJson.json();
        } catch (error) {
            return error.message;
        }
    }

    async checkUser(email) {
        const requestOptions = {
            method: 'POST',
            headers: reqHeaders,
        };

        try {
            const respJson = await fetch(`${Endpoints.checkUser}${email}`, requestOptions);
            return await respJson.json();
        } catch (error) {
            return error.message;
        }
    }

    async sendOrigin(origin) {
        const requestOptions = {
            method: 'POST',
            headers: reqHeaders,
        };

        try {
            const respJson = await fetch(`${Endpoints.origin}${origin}`, requestOptions);
            const resp = await respJson.json();
            return resp;
        } catch (err) {
            return err.message;
        }
    }
    async checkCampaign() {
        const requestOptions = {
            method: 'GET',
            headers: reqHeaders,
        };

        try {
            const respJson = await fetch(`${Endpoints.checkCampaign}`, requestOptions);
            return await respJson.json();
        } catch (err) {
            return err.message;
        }
    }
    async resendEmail(email) {
        const requestOptions = {
            method: 'POST',
            headers: reqHeaders,
        };

        try {
            const respJson = await fetch(`${Endpoints.resendEmail}${email}`, requestOptions);
            const resp = await respJson.json();
            return resp;
        } catch (err) {
            return err.message;
        }
    }

    async verifyRecaptchaToken(token) {
        const requestOptions = {
            method: 'POST',
            headers: reqHeaders,
        };
        try {
            const response = await fetch(
                `${Endpoints.verifyRecaptchaToken}/${token}`,
                requestOptions
            );
            const respJson = await response.json();
            return respJson;
        } catch (err) {
            return err.message;
        }
    }

    async getCampaignContent() {
        const requestOptions = {
            method: 'GET',
        };

        try {
            const respJson = await fetch(
                `${Endpoints.getCampaignContent}/${CAMPAIGNID}`,
                requestOptions
            );

            return await respJson.json();
        } catch (err) {
            return err.message;
        }
    }

    async checkUrlToken(token) {
        const requestOptions = {
            method: 'GET',
            headers: reqHeaders,
        };
        try {
            const respJson = await fetch(`${Endpoints.checkUrlToken}${token}`, requestOptions);
            return await respJson.json();
        } catch (error) {
            return error.message;
        }
    }

    async whatsappShareIncrement() {
        const requestOptions = {
            method: 'POST',
            headers: reqHeaders,
        };
        try {
            const respJson = await fetch(`${Endpoints.whatsappShare}`, requestOptions);
            return await respJson.json();
        } catch (error) {
            return error.message;
        }
    }

    async validateEmail(email) {
        const requestOptions = {
            method: 'POST',
            headers: reqHeaders,
        };

        try {
            const respJson = await fetch(`${Endpoints.validateEmail}/main${email}`, requestOptions);
            return await respJson.json();
        } catch (error) {
            return error.message;
        }
    }

    async getIntegrationSession(token) {
        try {
            const resp = await fetch(`${Endpoints.integrationSession}${token}`);
            return await resp.json();
        } catch (error) {
            return { result: false, data: null, error: error.message };
        }
    }

    async claimIntegrationSession(token, status) {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        try {
            const resp = await fetch(Endpoints.integrationClaim, {
                method: 'POST',
                headers,
                body: JSON.stringify({ token, status }),
            });
            return await resp.json();
        } catch (error) {
            return { result: false, data: null, error: error.message };
        }
    }
}

export default new Api();
